<template>
  <popper
    trigger="hover"
    :options="{
      placement: 'bottom',
      modifiers: { offset: { offset: '0,10px' } }
    }">
    <div class="popper" v-show="alt">
      {{ alt }}
    </div>

    <button class="btn p-0" slot="reference"
      v-on:mouseover="hover = true"
      v-on:mouseout="hover = false">
      <img :src="imgOn" v-if="hover" />
      <img :src="imgOff" v-else />
    </button>
  </popper>
</template>

<script>
import Popper from 'vue-popperjs'
import 'vue-popperjs/dist/css/vue-popper.css'

export default {

  name: 'IconButton',

  components: {
    'popper': Popper
  },

  props: {
    name: {
      type: String,
      required: true,
      default: ''
    },

    alt: {
      type: String,
      required: false,
      default: ''
    }
  },

  data () {
    return {
      hover: false,
      imgOn: null,
      imgOff: null
    }
  },

  mounted () {
    this.imgOn = require('../../assets/image/icon/' + this.name + '_on.png')
    this.imgOff = require('../../assets/image/icon/' + this.name + '_off.png')
  }
}
</script>

<style lang="scss">
.popper {
  background-color: #fafafa!important;
  border-color: #fafafa!important;
  .popper__arrow {
    border-color: transparent transparent #fafafa transparent !important;
  }
}
</style>


// WEBPACK FOOTER //
// IconButton.vue?8fbc3560